module.exports = __webpack_public_path__ + "static/img/fast-and-furious.c779d99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/fast-and-furious.jpg
// module id = qLTE
// module chunks = 0